import email from './images/email.jpeg'
import github from './images/github.png'
import linkedin from './images/linkedin.png'
import location from './images/location.png'
import phone from './images/phone.jpeg'
import profilepic from './images/profile_pic.png'

import HTML5 from './images/html5-logo.png'
import css from './images/css.png'
import javascript from './images/javascript.png'
import ruby from './images/ruby.png'
import rubydark from './images/ruby_dark.jpeg'
import ruby_on_rails from './images/ruby-on-rails.png'
import postgresql from './images/postgresql.png'
import python from './images/python.png'
import flask from './images/flask.png'
import bootstrap from './images/bootstrap-logo.svg'
import node from './images/node.png'
import sinatra from './images/sinatra_logo.png'
import typescript from './images/typescript_logo.png'
import react from './images/react_logo.png'
import reactdark from './images/react_dark.png'
import mySQL from './images/mySQL_logo.png'
import heroku from './images/heroku.png'
import JobsTrackerApp from './images/JobsTrackerApp.png'
import TicTacToe from './images/TicTacToe.png'
import CodingResources from './images/CodingResources.png'
import RubberDuck from './images/duck 1.jpeg'
import RubberDuckNoBackground from './images/duck_1-removebg.png'
import Resume from './images/Internet Resume.png'
// import Resume from './images/Bree_Van_Eerden_PDF_2022.pdf'

{/* <img src={images.other[8].image} alt="" /> */}


const images = {
  skills: [
    {
      title: "HTML5",
      image: HTML5
    },
    {
      title: "CSS",
      image: css
    },
    {
      title: "JavaScript",
      image: javascript
    },
    {
      title: "Bootstrap",
      image: bootstrap
    },
    {
      title: "Node",
      image: node
    },
    {
      title: "Python",
      image: python
    },
    {
      title: "Flask",
      image: flask
    },
    {
      title: "Ruby",
      image: ruby
    },
    {
      title: "Sinatra",
      image: sinatra
    },
    {
      title: "MySQL",
      image: mySQL
    },
    {
      title: "Postgresql",
      image: postgresql
    },
    {
      title: "React",
      image: react
    },
    {
      title: "Github",
      image: github
    },
    {
      title: "Heroku",
      image: heroku
    }],
    skillsYetToAdd: [

    {
      title: "rubydark",
      image: rubydark
    },
    {
      title: "ruby_on_rails",
      image: ruby_on_rails
    },
    {
      title: "python",
      image: python
    },
    {
      title: "typescript",
      image: typescript
    },
    {
      title: "reactdark",
      image: reactdark
    },

  ],
    other: [
      {
        title: "CodingResources",
        image: CodingResources
      },
      {
        title: "TicTacToe",
        image: TicTacToe
      },
      {
        title: "JobsTrackerApp",
        image: JobsTrackerApp
      },
      {
        title: "email",
        image: email
      },
      {
        title: "github",
        image: github
      },
      {
        title: "linkedin",
        image: linkedin
      },
      {
        title: "location",
        image: location
      },
      {
        title: "phone",
        image: phone
      },
      {
        title: "profilepic",
        image: profilepic
      },
      {
        title: "RubberDuck",
        image: RubberDuck
      },
      {
        title: "RubberDuckNoBackground",
        image: RubberDuckNoBackground
      },
      {
        title: "Resume",
        image: Resume
      },
    ]

}

// const images = {
//   HTML5,
//   css,
//   javascript,
//   ruby,
//   rubydark,
//   ruby_on_rails,
//   postgresql,
//   python,
//   bootstrap,
//   node,
//   sinatra,
//   typescript,
//   react,
//   reactdark,
//   mySQL,
//   heroku,
//   CodingResources,
//   TicTacToe,
//   JobsTrackerApp,
//   email,
//   github,
//   linkedin,
//   location,
//   phone,
//   profilepic
// }

export { images }



          // https://medium.com/swlh/create-a-reactjs-advanced-wheel-carousel-b88ec253788d
